module.exports = __webpack_public_path__ + "img/dream_invite_white.4ae5cc6f.png";